// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectAction_root__2LIPz"};